import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import apiClient from '@/lib/api';

try {
  if (typeof window !== 'undefined') {
    apiClient
      .get('/admin/system')
      .then((r) => {
        const tz = (r.data && r.data.display_timezone) || null;
        if (tz) {
          localStorage.setItem('display_timezone', tz);
        }
      })
      .catch(() => {});
  }
} catch {}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);